import React from "react";
import Banner from "../../components/UserSideComponents/propertyPage.jsx/Banner";
import Hostel from "../../components/UserSideComponents/propertyPage.jsx/Hostel";
// import HousingRule from "../../components/UserSideComponents/propertyPage.jsx/HousingRule";
// import Comprehensive from "../../components/UserSideComponents/propertyPage.jsx/Comprehensive";
import { useParams } from "react-router-dom";
import PropertyFooter from "../../components/UserSideComponents/propertyPage.jsx/PropertyFooter";
import LinkTab from "../../components/UserSideComponents/propertyPage.jsx/HousingRule";

function PropertyPage() {
  const { location } = useParams();
  console.log("Location : ", location);
  return (
    <div>
      <Banner />
      <Hostel />

      <LinkTab title="How to Book" navigateTo="how-it-works" />
      <LinkTab title="FAQ" navigateTo="faq" />
      {/* <Comprehensive /> */}
      <PropertyFooter />
    </div>
  );
}

export default PropertyPage;
